import { Languages } from "lucide-react";
import { Reveal } from "./Reveal";
import { Waveform } from "./Waveform";
import { LANDING } from "@/data/pageCopy";


const { ai, pbx } = LANDING.features;
const aiFeatures = ai.items;
const pbxFeatures = pbx.items;

export const Features = () => (
  <section id="features" className="relative py-24 md:py-32 bg-[#0a0a0a] border-t border-white/10" data-testid="features-section">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      {/* AI agent block */}
      <div id="ai-agent" className="scroll-mt-24">
        <Reveal>
          <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-4">{ai.kicker}</p>
          <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl lg:text-5xl max-w-3xl text-white">
            {ai.h2}
          </h2>
          <p className="mt-5 text-neutral-400 max-w-xl">
            {ai.lead}
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {/* highlighted multilingual card — blue accent border to stand out on dark */}
          <Reveal className="md:col-span-2 md:row-span-2">
            <div className="relative h-full bg-white/[0.04] text-white p-8 md:p-10 flex flex-col justify-between min-h-[280px]">
              <span className="absolute top-0 left-0 right-0 h-[2px] bg-[#5B8CFF]" />
              <div>
                <Languages className="text-[#5B8CFF]" size={28} />
                <h3 className="mt-6 font-heading font-semibold text-2xl">{ai.highlight.t}</h3>
                <p className="mt-3 text-neutral-400 text-sm max-w-sm leading-relaxed">
                  {ai.highlight.d}
                </p>
              </div>
              <div className="mt-8">
                <Waveform bars={52} height={60} color="#ffffff" />
              </div>
            </div>
          </Reveal>

          {aiFeatures.map((f, i) => (
            <Reveal key={f.t} delay={(i % 4) * 0.06}>
              <div className="h-full bg-white/[0.02] p-6 hover:bg-white/[0.05] transition-colors duration-300 group">
                <f.icon className="text-neutral-500 group-hover:text-white transition-colors" size={22} />
                <h4 className="mt-5 font-semibold text-[15px] leading-snug text-white">{f.t}</h4>
                <p className="mt-2 text-neutral-400 text-[13px] leading-relaxed">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* PBX foundation */}
      <div className="mt-20">
        <Reveal>
          <div className="flex items-end justify-between flex-wrap gap-4">
            <div>
              <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-neutral-500 mb-3">{pbx.kicker}</p>
              <h3 className="font-heading font-semibold text-2xl md:text-3xl text-white">{pbx.h3}</h3>
            </div>
            <p className="font-mono-t text-xs text-neutral-500">{pbx.aside}</p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {pbxFeatures.map((f, i) => (
            <Reveal key={f.t} delay={(i % 3) * 0.05}>
              <div className="bg-white/[0.02] px-6 py-6 flex items-center gap-4 hover:bg-white/[0.05] transition-colors duration-300">
                <f.icon className="text-white shrink-0" size={20} />
                <span className="font-medium text-sm text-white">{f.t}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
